// extracted by mini-css-extract-plugin
export default {"button":"ColorSchemeAction_button__lVE3h","active":"ColorSchemeAction_active__a2o19","colorPaletteWrapper":"ColorSchemeAction_colorPaletteWrapper__1iYxc"};